export default {
  attachmentIds: {
    type: 'array',
    maxSize: 5,
  },
};
